var filter = function() {
  return function(input) {
    if (input === null || input === undefined) { return ''; }
    return moment(input).fromNow();
  };
}

tiz.filter('fromNow', filter);
